"use strict";

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var get = require('../getValueOfKeyMatching');

function ThankYouCards(params) {
  var quantity = parseInt(get(params, /thankYouCards/), 10);
  var guest_addressing = parseBoolean(get(params, /ty_guestAddressing|REPRINT_inv_guestAddressing/));
  var return_addressing = parseBoolean(get(params, /^ty_returnAddressing|REPRINT_inv_returnAddressing/));
  var custom_postage = parseBoolean(get(params, /inv_customPostage/));
  var has_personalization = parseBoolean(get(params, /tyPers/));
  var backside_printing = params.backside_printing == null ? null : parseBoolean(params.backside_printing);
  this.personalization.push({
    name: 'Interior Message',
    value: get(params, /pers_tyPers/)
  });
  this.personalization.push({
    name: 'Name and Date',
    value: get(params, /pers_thankyou_namedate/)
  });
  this.personalization.push({
    name: 'Return Address',
    value: get(params, /pers_ty_returnAddressing/)
  });
  this.thankYouCards.add({
    quantity: quantity,
    has_personalization: has_personalization,
    backside_printing: backside_printing
  });
  this.thankYouCardEnvelopes.add({
    quantity: quantity,
    guest_addressing: guest_addressing,
    return_addressing: return_addressing,
    custom_postage: custom_postage
  });
}

module.exports = ThankYouCards;